import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
import compareMixin from '@/mixins/compare.mixin';
import { getPortfolioTokensWithFirstBaseToken } from '@/helpers/portfolio.helper';
import { isMultichainToken } from '@/helpers/token.helper';
import { Portfolio } from '@/sdk/entities/portfolio';
import { PortfolioSource } from '@/sdk/entities/PortfolioSource';
import PortfolioHeaderData from './portfolioHeader/PortfolioHeaderData.vue';
import PortfolioCompound from './portfolioCompound/PortfolioCompound.vue';
import ControlPanelCollapse from '@/components/ControlPanelCollapse.vue';
import TokenGroupIcon from '@/components/token/TokenGroupIcon.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import brandedPortfoliosConfig from '@/helpers/brandedPortfoliosConfig.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'Portfolio',
  props: {
    portfolio: null,
    openAfterCreated: { type: Boolean }
  },
  emits: ["sendTransaction"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'sendTransaction'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolio: Portfolio;
  openAfterCreated: boolean;
}

const { compareAddresses } = compareMixin.methods;





const brandedPortfolioInfo = computed(() => {
  return brandedPortfoliosConfig.find(brandedPortfolio =>
    compareAddresses(brandedPortfolio.contractAddress, props.portfolio.contractAddress),
  );
});
const isCrosschainPortfolio = computed(() => {
  return props.portfolio.type === PortfolioSource.PORTFOLIO_CROSSCHAIN;
});
const isMultichainTokensInPortfolio = computed(() => {
  return !!props.portfolio.tokens.find(token => isMultichainToken(token.token.symbol ?? ''));
});

function getPortfolioTokens() {
  return getPortfolioTokensWithFirstBaseToken(props.portfolio).map(token => token.token);
}
function sendTransaction() {
  emits('sendTransaction');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ControlPanelCollapse, {
    name: __props.portfolio.name,
    expanded: __props.openAfterCreated,
    brand: _unref(brandedPortfolioInfo)?.brand,
    "brand-icon": _unref(brandedPortfolioInfo)?.icon,
    crosschain: _unref(isCrosschainPortfolio),
    "toggle-inline": "",
    class: "overflow-visible"
  }, {
    "header-title": _withCtx(() => [
      _createVNode(TokenGroupIcon, {
        tokens: getPortfolioTokens()
      }, null, 8, ["tokens"])
    ]),
    "header-data": _withCtx(() => [
      _createVNode(PortfolioHeaderData, { portfolio: __props.portfolio }, null, 8, ["portfolio"])
    ]),
    default: _withCtx(() => [
      (_unref(isMultichainTokensInPortfolio))
        ? (_openBlock(), _createBlock(InfoMessage, {
            key: 0,
            type: "warning",
            icon: "error",
            "as-panel": "",
            message: _ctx.$t('portfolio.infoMessage.multichainTokens'),
            class: "mb-s3"
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createVNode(PortfolioCompound, {
        portfolio: __props.portfolio,
        onSendTransaction: sendTransaction
      }, null, 8, ["portfolio"])
    ]),
    _: 1
  }, 8, ["name", "expanded", "brand", "brand-icon", "crosschain"]))
}
}

})